import { useDirectoryExists } from "files/hooks/useFiles";
import { projectFilesKey } from "files/hooks/useProjectFilesContext";
import BaseDirectory from "files/types/enums/baseDirectory";
import { nextgenProjectFilesPath } from "~/pages/manifold-nextgen/paths";
import { useProjectLayout } from "./ProjectLayoutContext";

export interface ProjectFilesTarget {
  // Where a saved artifact lands: the project files `exports` folder.
  exportsPath: string;
}

/** The project files an artifact could be saved to from here.
 *
 * Null outside a project route, and for a project whose files directory does
 * not exist: only projects provisioned with project files have one. Undefined
 * while that is still being checked. Any member may save; the server enforces
 * write access. Null, with no check made, when `enabled` is false.
 */
export const useProjectFilesTarget = (enabled = true): ProjectFilesTarget | null | undefined => {
  const context = useProjectLayout();
  const projectUuid = context?.project?.id;
  const hasProjectFiles = useDirectoryExists(
    enabled && projectUuid ? projectFilesKey(projectUuid) : undefined
  );
  if (!context || !enabled) return null;
  if (hasProjectFiles === null) return undefined;
  if (!hasProjectFiles) return null;
  return {
    exportsPath: `${nextgenProjectFilesPath(context.projectId)}/${BaseDirectory.PROJECT_FILES}/exports`,
  };
};
